<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #EDEFF2',
    }"
  >
    <!-- 题目类型标签 -->
    <div class="question-type">矩阵单选</div>

    <!-- 题目标题 -->
    <div class="title-view">
      <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </span>
    </div>

    <!-- 题目图片展示 -->
    <div class="question-images">
      <div
        v-for="(item, index) in images"
        :key="index"
        style="margin-top: 10px; position: relative; cursor: pointer"
        @click="showBigImage(item, { text: dataObj.caseProblem })"
      >
        <img :src="item" style="width: 100%; border-radius: 4px" />
      </div>
    </div>

    <!-- 矩阵标题区域 -->
    <div class="matrix-header">
      <div class="matrix-header-item">
        <div>{{ horizontalTitle }}</div>
      </div>
      <div
        class="matrix-header-item"
        v-for="(col, colIndex) in percentageTitles"
        :key="colIndex"
      >
        <div>{{ col.text }}</div>
      </div>
    </div>

    <!-- 矩阵选项区域 -->
    <div v-for="(option, index) in list" :key="index" class="matrix-options">
      <div class="matrix-options-item">
        <!-- 原版 -->
        <!-- <textarea
          v-model="option.context"
          maxlength="500"
          :disabled="true"
          class="matrix-textarea"
          style="height: auto"
        ></textarea> -->
        <div>{{ option.context }}</div>
      </div>
      <div
        class="matrix-options-item"
        v-for="(col, colIndex) in percentageTitles"
        :key="colIndex"
      >
        <el-checkbox
          size="mini"
          @change="(val) => changeCheckbox(val, index, colIndex)"
          :checked="getCheckValue(index, colIndex)"
        ></el-checkbox>
      </div>
    </div>

    <!-- 图片预览弹窗（替代小程序自定义弹窗） -->
    <el-dialog
      title="图片预览"
      :visible.sync="fangdaShow"
      width="80%"
      @close="fangdaClose"
    >
      <div class="popup-scroll">
        <div>{{ fangdaTitle }}</div>
        <img :src="fangdaImgUrl" style="width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "QuestionMatrixRadio",
  // Vue2 定义Props
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    updateType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dataObj: {},
      index: 0,
      ifRandomize: false,
      isMust: false,
      showpopup: false,
      showUpload: false,
      uploadIndex: 0,
      images: [],
      caseProblem: "",
      isFocusIndex: "",
      inputFocusIndex: "",
      verticalNum: 2, // 竖列 2-3
      showVerticalNum: false, // 是否显示竖列
      defaultVerticalNum: [1], // 默认竖列 2-3
      horizontalTitle: "横标题",
      percentageTitles: [{ text: "满意" }, { text: "不满意" }],
      numColumns: [
        [
          { id: 2, label: "2" },
          { id: 3, label: "3" },
        ],
      ],
      answerObj: {}, // 答案对象
      // 替代 Vue3 ref
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听props.dataObj变化
    params: {
      handler(newValue) {
        // 深拷贝避免引用问题
        this.dataObj = { ...newValue.data };
        this.index = newValue.index || 0;
        this.caseProblem = newValue.caseProblem || "";

        // 解析矩阵核心数据
        const chooseList = JSON.parse(
          newValue.data.chooseList ||
            '{"list":[],"verticalNum":2,"percentageTitle":"满意,不满意","horizontalTitle":"横标题"}',
        );
        this.list = chooseList.list || [];
        this.verticalNum = chooseList.verticalNum || 2;
        this.horizontalTitle = chooseList.horizontalTitle || "横标题";

        // 解析竖列标题
        this.percentageTitles = (chooseList.percentageTitle || "满意,不满意")
          .split(",")
          .map((item) => ({ text: item }));

        this.isMust = this.dataObj.isMust === 1;
        this.images = JSON.parse(newValue.data.caseProblemImg || "[]");

        console.log("矩阵单选数据解析完成：", this.dataObj);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 矩阵复选框切换（核心单选逻辑）
    changeCheckbox(event, index, colIndex) {
      console.log("复选框切换：", event, index, colIndex);

      // 清空当前行所有列的选中状态
      this.list[index].oneId = "";
      this.list[index].twoId = "";
      this.list[index].threeId = "";

      // 设置当前列选中状态
      if (event) {
        if (colIndex === 0) {
          this.list[index].oneId = "1";
        } else if (colIndex === 1) {
          this.list[index].twoId = "1";
        } else {
          this.list[index].threeId = "1";
        }
      } else {
        if (colIndex === 0) {
          this.list[index].oneId = "";
        } else if (colIndex === 1) {
          this.list[index].twoId = "";
        } else {
          this.list[index].threeId = "";
        }
      }

      this.handleUpdate();
      console.log("当前行选中状态：", this.list[index]);
    },
    // 获取复选框选中状态
    getCheckValue(index, colIndex) {
      console.log("获取选中状态：", index, colIndex);
      if (colIndex === 0) {
        return this.list[index].oneId === "1";
      } else if (colIndex === 1) {
        return this.list[index].twoId === "1";
      } else {
        return this.list[index].threeId === "1";
      }
    },
    // 组装数据并触发update事件
    handleUpdate() {
      // 更新矩阵选择数据
      this.dataObj.chooseList = JSON.stringify({
        list: this.list,
        verticalNum: this.verticalNum,
        percentageTitle: this.percentageTitles
          .map((item) => item.text)
          .join(","),
        horizontalTitle: this.horizontalTitle,
      });

      // 组装答案对象
      this.answerObj = {
        question_id: this.dataObj.id,
        type: this.dataObj.type,
        answer: this.list.map((item) => ({
          id: item.id,
          oneId: item.oneId,
          twoId: item.twoId,
          threeId: item.threeId,
        })),
        if_hide: this.dataObj.if_hide,
      };

      // 触发update事件
      this.$emit(
        "update",
        JSON.stringify({
          data: this.dataObj,
          index: this.index,
          answer: this.answerObj,
        }),
      );
    },
    // 竖列数量确认（保留方法，兼容原逻辑）
    handleVerticalNumConfirm(e) {
      console.log("竖列数量选择：", e);
      this.verticalNum = e.value[0].id || 2;
      this.showVerticalNum = false;

      // 更新竖列标题
      if (this.verticalNum === 2) {
        this.percentageTitles = [{ text: "满意" }, { text: "不满意" }];
      } else if (this.verticalNum === 3) {
        this.percentageTitles = [
          { text: "满意" },
          { text: "不满意" },
          { text: "中立" },
        ];
      }

      this.handleUpdate();
    },
    // 图片预览
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text || "";
    },
    // 关闭图片预览
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
// 基础样式重置
* {
  box-sizing: border-box;
}

.question-container {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}

// 题目图片区域
.question-images {
  margin-bottom: 10px; // 20rpx → 10px

  img {
    width: 100%;
    border-radius: 4px; // 8rpx → 4px
  }
}

// 矩阵标题样式
.matrix-header {
  display: flex;
  margin-bottom: 10px; // 20rpx → 10px
  box-sizing: border-box;
  width: 100%;
}

.matrix-header-item {
  flex: 1;
  margin-left: 10px; // 20rpx → 10px
  text-align: center;
  padding: 5px 0; // 6rpx 10rpx → 3px 5px

  &:first-child {
    flex: 2;
    margin-left: 0;

    div {
      padding: 10px 5px; // 6rpx 10rpx → 3px 5px
      box-sizing: border-box;
      text-align: left;
      justify-content: flex-start;
    }
  }

  div {
    width: 100%;
    padding: 3px; // 6rpx → 3px
    border: 1px solid #dcdde0;
    border-radius: 4px; // 8rpx → 4px
    text-align: center;
    font-size: 14px; // 28rpx → 14px
    color: #4c4a56;
    white-space: normal;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// 矩阵选项样式
.matrix-options {
  display: flex;
  margin-bottom: 10px; // 20rpx → 10px
  box-sizing: border-box;
  align-items: center;
  border: 1px dashed #3a60ff; // 2rpx → 1px
  border-radius: 2.5px; // 5rpx → 2.5px
  // padding: 5px;
}

.matrix-options-item {
  flex: 1;
  margin-left: 10px; // 20rpx → 10px
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;

  &:first-child {
    flex: 2;
    margin-left: 0;
    justify-content: flex-start;
  }

  .matrix-textarea {
    width: 100%;
    padding: 5px 10px; // 10rpx 20rpx → 5px 10px
    font-size: 14px; // 28rpx → 14px
    color: #2b2f36;
    resize: none;
    outline: none;
    border: none;
    min-height: 16px; // 32rpx → 16px;
    overflow-wrap: break-word;
    word-break: break-all;
    background: transparent;
    height: auto;
  }
}

// 图片预览弹窗
.popup-scroll {
  width: 100%;
  padding: 10px;

  div {
    font-size: 16px;
    margin-bottom: 10px;
    color: #333;
  }

  img {
    max-width: 100%;
    max-height: 600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewMatrixScq.vue